import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import { RootStyled } from './upload-thumbnail-video.styled';
import { Stack } from '@mui/material';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';
import { useTranslation } from 'react-i18next';

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children?: React.ReactNode;
}
export const UploadThmbnailVideo = ({ children, ...props }: Props) => {
  const { t } = useTranslation();
  if (children) return <RootStyled>{children}</RootStyled>;
  return (
    <RootStyled {...props}>
      <Stack alignItems={'center'}>
        <PhotoIcon width={IconSize.md} />
        <span>{t('IMPORT_VIDEO')}</span>
      </Stack>
    </RootStyled>
  );
};
